export const DB_VERSION_CURRENT = 1
export const DB_VERSION_INITIAL = 1
export const STORE_EMOJI = 'emoji'
export const STORE_KEYVALUE = 'keyvalue'
export const STORE_FAVORITES = 'favorites'
export const FIELD_TOKENS = 'tokens'
export const INDEX_TOKENS = 'tokens'
export const FIELD_UNICODE = 'unicode'
export const INDEX_COUNT = 'count'
export const FIELD_GROUP = 'group'
export const FIELD_ORDER = 'order'
export const INDEX_GROUP_AND_ORDER = 'group-order'
export const KEY_ETAG = 'eTag'
export const KEY_URL = 'url'
export const KEY_PREFERRED_SKINTONE = 'skinTone'
export const MODE_READONLY = 'readonly'
export const MODE_READWRITE = 'readwrite'
export const INDEX_SKIN_UNICODE = 'skinUnicodes'
export const FIELD_SKIN_UNICODE = 'skinUnicodes'

export const DEFAULT_DATA_SOURCE = 'https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/en/emojibase/data.json'
export const DEFAULT_LOCALE = 'en'
